import React, { useEffect, useState } from 'react'
import BossDialog from '../../components/BossDialog'
import moment from 'moment';
import * as API from '../../framework/API/api';
import { useTranslation } from '../../locale/useTranslation';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import { toast } from 'react-toastify';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import { ADS_TYPE, ENTITYNAME } from '../../framework/constant/constant';
import InsightCard from './InsightCard';

const SMInsightsForm = (props) => {

    const { item = {}, onClose } = props;

    const lang = useTranslation();

    const blankDataItem = {
        ...item,
        fromDate: item?.start_time ? moment(item?.start_time).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        toDate: item?.end_time ? moment(item?.end_time).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [isLoading, setIsLoading] = useState(false);
    const [insightsData, setInsightsData] = useState([]);

    useEffect(() => {
        if (item) {
            getInsights();
        }
    }, [item]);

    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    };

    const getInsights = async () => {
        setIsLoading(true);
        let res = await API.getData(ENTITYNAME.SM_Insights, { query: ["campaign_id", "=", item._id] });
        setInsightsData(res.data);
        setIsLoading(false);
    }

    const isValid = () => {
        if (!dataItem.fromDate) {
            toast.error(lang.from_date_label, { position: toast.POSITION.TOP_RIGHT });
            return false;
        }
        if (!dataItem.toDate) {
            toast.error(lang.to_date_label, { position: toast.POSITION.TOP_RIGHT });
            return false;
        }
        if (dataItem.toDate < dataItem.fromDate) {
            toast.error(
                <div>
                    <strong>INVALID</strong>
                    <div style={{ fontSize: '13px' }}>{lang.to_date_cannot_be_earlier_than_from_date_message}</div>
                </div>,
                { position: toast.POSITION.TOP_RIGHT }
            );
            return false;
        }
        return true;
    };

    const loadData = async () => {
        if (!isValid()) return;

        const getFinalData = () => {
            switch (dataItem?.channel?.adType) {
                case ADS_TYPE.META:
                    return {
                        fields: "impressions,clicks,spend,ctr,cpc,cpm",
                        id: dataItem.metaCampaignId, // "120209885533580570",
                        time_range: { "since": moment(dataItem.fromDate).format("YYYY-MM-DD"), "until": moment(dataItem.toDate).format("YYYY-MM-DD") }
                    };
                case ADS_TYPE.LINKEDIN:
                    console.log(dataItem);
                    return {
                        id: dataItem?.linkedin?.campaignId,
                        pivot: "CREATIVE",
                        dateRange: { start: { year: moment(dataItem.fromDate).year(), month: moment(dataItem.fromDate).month(), day: moment(dataItem.fromDate).date() }, end: { year: moment(dataItem.toDate).year(), month: moment(dataItem.toDate).month(), day: moment(dataItem.toDate).date() } },
                    };
            }

        }
        let finalData = {
            adsConfig: dataItem.channel,
            campaign_id: item?._id,
            ...getFinalData(),
        };
        console.log(finalData);
        const res = await API.getInsightViaId(finalData);
        console.log(res);

        if (res.success) {
            setInsightsData(res.data);
        } else {
            toast.error(lang.error_fetching_insights, { position: toast.POSITION.TOP_RIGHT });
        }
    }

    const summaryData = [
        {
            label: lang.impressions_label,
            value: insightsData.reduce((sum, item) => sum + (parseInt(item.impressions) || 0), 0),
        },
        {
            label: lang.clicks_label,
            value: insightsData.reduce((sum, item) => sum + (parseInt(item.clicks) || 0), 0),
        },
        {
            label: lang.spends_label,
            value: insightsData.reduce((sum, item) => sum + (parseFloat(item.spend) || 0), 0),
        },
        {
            label: lang.cpc_label,
            value: insightsData.length ? (insightsData.reduce((sum, item) => sum + (parseFloat(item.cpc) || 0), 0) / insightsData.length).toFixed(2) : '0',
        },
        {
            label: lang.cpm_label,
            value: insightsData.length ? (insightsData.reduce((sum, item) => sum + (parseFloat(item.cpm) || 0), 0) / insightsData.length) : '0',
        },
        {
            label: lang.ctr_label,
            value: insightsData.length ? (insightsData.reduce((sum, item) => sum + (parseFloat(item.ctr) || 0), 0) / insightsData.length).toFixed(2) + '%' : '0%',
        },
    ];

    return (
        <>
            <BossDialog title={`Campaign Insights - ${item.name}`} height="auto" width={"620px"} onClose={onClose} >
                <div className='d-flex justify-content-between align-items-center'>
                    <div className='d-flex align-items-center'>
                        <div className='mr-3'>
                            <label htmlFor="fromDate">{lang.from_date_label}*</label>
                            <input type="date" name='fromDate' value={dataItem.fromDate} onChange={onChange} className='form-control form-control-sm' />
                        </div>
                        <div className='mr-3'>
                            <label htmlFor="toDate">{lang.to_date_label}*</label>
                            <input type="date" name='toDate' value={dataItem.toDate} onChange={onChange} className='form-control form-control-sm' />
                        </div>
                        <div style={{ marginTop: '17px' }}>
                            <ActionButton name={lang.show_button_text} btnColor={'primary'} onClick={getInsights} disabled={isLoading} isLoading={isLoading} />
                        </div>
                    </div>
                    <div className='d-flex align-items-center' style={{ marginTop: '17px' }}>
                        <RoundButton onClick={loadData} title="Refresh Insights" icon="refresh" />
                    </div>
                </div>
                <div className='mt-3'>Campaign Insights</div>
                <div className='border' style={{ backgroundColor: '#F4F5FA' }}>
                    <InsightCard
                        data={summaryData}
                        containerStyle={{ padding: '10px', display: 'flex', gap: '0.4rem', overflowX: 'auto', whiteSpace: 'nowrap', flexWrap: 'wrap' }}
                    />
                </div>
            </BossDialog>
        </>
    )
}

export default SMInsightsForm
